import {CopyData} from "../../../../../../../components/ui/CopyData";

export const FormatCellCopy = ({ row }) => {
  const ip = row?.proxyType === "IPv6" ? `${row?.innerIp}:${row?.port}` : row.innerIp;

  return (
    <CopyData data={ip} />
  );
};
